var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWifiSignalMedium(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ionicons-v5-r") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M332.41,310.59a115,115,0,0,0-152.8,0",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 32
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.46,249.54a201.26,201.26,0,0,0-274.92,0",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 32
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.72,182.11a288,288,0,0,0-383.44,0",
    style: {
      fill: "none",
      stroke: "#555",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 32
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256,416a32,32,0,1,1,32-32A32,32,0,0,1,256,416Z",
    style: {
      fill: "#fff",
      stroke: "#fff"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWifiSignalMedium);
export default __webpack_public_path__ + "static/media/wifi-signal-medium.5c94122eb6b697f3d918bfa1f2e686b7.svg";
export { ForwardRef as ReactComponent };